import {
  TacticalSlot,
  type ScoutingGetWatchlistPitchQuery,
} from "@/generated/graphql";

/** Authorized watchlist Pitch query payload. */
type Pitch = NonNullable<ScoutingGetWatchlistPitchQuery["getWatchlistPitch"]>;
/** One ordered watchlist member. */
type Member = Pitch["members"]["edges"][number]["node"];

/**
 * Formats the GraphQL formation enum for display.
 * @param formation - Formation enum value.
 * @returns Hyphenated display label.
 */
export const formatPitchFormation = (formation: string): string =>
  formation.replace("F_", "").split("").join("-");

/**
 * Formats nullable GPR values for compact Pitch labels.
 * @param gpr - Overall GPR value.
 * @returns Rounded GPR or an unavailable marker.
 */
export const formatPitchGpr = (gpr?: number | null): string =>
  typeof gpr === "number" ? Math.round(gpr).toString() : "—";

/**
 * Groups assigned watchlist members by tactical slot.
 * @param members - Ranked watchlist members.
 * @returns Members keyed by assigned tactical slot.
 */
export const groupPitchMembers = (members: readonly Member[]) =>
  members.reduce<Partial<Record<TacticalSlot, Member[]>>>((groups, member) => {
    if (!member.effectiveSlot) return groups;
    return {
      ...groups,
      [member.effectiveSlot]: [...(groups[member.effectiveSlot] ?? []), member],
    };
  }, {});
